import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightSm16 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M6 12L10 8L6 4", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor" })));
const ForwardRef = forwardRef(SvgChevronRightSm16);
export { ForwardRef as ReactComponent };
